import ContainerFlex from "components/ContainerFlex";
import * as St from "../styles";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { useEffect, useRef, useState } from "react";
import AppButton from "components/AppButton/AppButton";
import { RouteNames } from "routes/routes";
import { useHistory } from "react-router-dom";
import { addTypeFlowState } from "redux/features/security/security-slice";
import ReactToPrint from "react-to-print";
import PrintPaymentResumeAntecipation from "../components/PrintPaymentResumeAntecipation";
import useApi, { ApiMethod } from "hooks/useApi";
import Endpoints from "services/api/endpoints";

const ResumeAntecipationPayment = () => {
  const [data, setData] = useState<any>(null);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const componentRef = useRef<HTMLIFrameElement>(null);
  const {
    cliente: { cpf },
  } = useAppSelector((state) => state.cliente);

  const clickBack = () => {
    history.push(RouteNames.ATENDIMENTO_ANTECIPACAO);
    dispatch(addTypeFlowState("antecipacao"));
  };

  const GetAntecipationLast = useApi<any>(
    Endpoints.cobranca.getAntecipationHistory.replace("PARAM_CPF", cpf || '').replace("PARAM_TIPO", "COMPRA"),
    ApiMethod.GET
  );

  const getAntecipationLast = async () => {
    const response = await GetAntecipationLast.callApi();
    if (response.status >= 200 && response.status < 300) {
      setData(response.data[0]);
    } else {
      return null;
    }
  };

  useEffect(() => {
    getAntecipationLast();
    // getAntecipationLast vem de useApi/e nao e memoizada; incluir causaria
    // refetch em loop a cada render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cpf]);

  return (
    <ContainerFlex>
      <St.TitleH1>Resumo de Solicitação de antecipacão</St.TitleH1>
      <ContainerFlex>
        <ContainerFlex center>
          <St.SpanDescription>Solicitação realizada!</St.SpanDescription>
        </ContainerFlex>
        <ContainerFlex center marginBottom={10}>
          <ContainerFlex center>
            <ContainerFlex
              padding={15}
              color="#fbfbfb"
              width={60}
              height={50}
              maxWidth={100}
              maxHeight={350}
              scroll
              hidden
            >
              <div ref={componentRef}>
                <PrintPaymentResumeAntecipation data={data}/>
              </div>
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex center padding={2}></ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <ContainerFlex center horizontal row space marginBottom={30}>
        <AppButton
          content="Voltar"
          route={RouteNames.ATENDIMENTO_HOME}
          outlined={true}
          click={clickBack}
        />

        <ReactToPrint
          trigger={() => <button className="normal">Imprimir</button>}
          content={() => componentRef.current}
        />
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default ResumeAntecipationPayment;
